import { render, staticRenderFns } from "./finalizar.vue?vue&type=template&id=cebe23da"
import script from "./finalizar.vue?vue&type=script&lang=js"
export * from "./finalizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports